/* global bocAmchart4 */

/**
 * Adds the titles based on the data from the group, in case the titles were not defined manually.
 * Skips everything if any titles are already defined.
 *
 * @param {object} data Object containing the valet data sets
 * @param {object} chart object
 * @returns {array} output array of data
 */
bocAmchart4.getChartTitlesFromGroup = function (data, chart) {

    if ((bocAmchart4.vars[chart.bocSettings.id].titlesContainer.children.length === 0)
        && data.hasOwnProperty("groupDetail")) {
        if (bocAmchart4.debug(chart)) {
            // eslint-disable-next-line no-console
            console.log(
                chart.bocSettings.id,
                "Adding titles from group metadata",
                ":",
                data.groupDetail.label,
                data.groupDetail.description
            );
        }

        bocAmchart4.addChartTitle(chart, 'charttitle', data.groupDetail.label);
        bocAmchart4.addChartTitle(chart, 'subtitle', data.groupDetail.description);
    }
};
